import React, { useState, useEffect } from "react";
import { Menu, X, Phone, Mail, Globe, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="31395" className="flex gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-20 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-bold uppercase tracking-tight text-foreground transition-all border-b-2 border-transparent hover:border-primary hover:text-primary py-1">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2 p-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-lg font-bold uppercase tracking-tight py-3 px-4 rounded-sm hover:bg-accent hover:text-primary transition-colors border-l-4 border-transparent hover:border-primary" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="tiefbau" className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-xl border-secondary/20 shadow-lg" : "bg-background border-secondary/10 shadow-none"}`}>
      <div className="container mx-auto px-4 h-24 flex items-center justify-between">
        
        <div className="flex items-center gap-4">
          <Link to="/HomePage" className="flex-shrink-0 flex flex-col items-center">
            <img src="https://joint-slug.10web.cloud/wp-content/uploads/2026/03/sticker.png" alt="BauPartner" className="h-[4cm] w-auto object-contain relative" />
            
          </Link>
          
          
          
          
          
        </div>

        
        <div className="hidden md:block">
          <MenuProvider menu_id="38" className="flex items-center">
            <DesktopMenuConsumer />
          </MenuProvider>
        </div>

        
        <div className="md:hidden">
          <Button variant="ghost" size="icon" className="text-foreground hover:text-primary" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu">
            <Menu className="h-6 w-6" />
          </Button>
        </div>
      </div>

      
      {isMobileMenuOpen && <div className="fixed inset-y-0 inset-x-0 z-50 bg-background/95 backdrop-blur-xl md:hidden animate-in fade-in slide-in-from-top-5 duration-300 overflow-hidden">
          <div className="container mx-auto px-4 py-4 flex flex-col h-full">
            <div className="flex items-center justify-between mb-8 h-12">
              <div className="flex items-center gap-3">
                 
                
              </div>
              <Button variant="ghost" size="icon" className="text-foreground" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu">
                <X className="h-6 w-6" />
              </Button>
            </div>
            
            <div className="flex-1 overflow-y-auto max-h-full">
              <MenuProvider menu_id="38">
                <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
              </MenuProvider>
            </div>

            <div className="py-8 border-t border-border mt-auto">
               <p className="text-sm font-mono text-muted-foreground text-center mb-4 uppercase tracking-tighter">
                 Regionaler Partner für Erdarbeiten & Tiefbau.
               </p>
               <div className="flex justify-center">
                 <Button asChild className="w-full max-w-xs bg-primary hover:bg-secondary text-primary-foreground rounded-sm transition-colors shadow-md">
                   <Link to="mailto:Info-TMBau@web.de">
                     <Phone className="mr-2 h-4 w-4" /> Projekt anfragen
                   </Link>
                 </Button>
               </div>
            </div>
          </div>
        </div>}
    </header>;
}